import React, { memo } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { CONTEXT } from '../../config';
import Loading from '../../components/Loading/Loading';
import hint from '../../static/wp_blank.png';
import styles from './Blank.module.less';
import { logging } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ load, more }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const handleSkip = () => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_LookAround',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    history.push(`${CONTEXT}/wprecommend`);
  };

  const macInfo = localStorage.getItem('LOCALMACHINE_INFO');
  let mac = null;
  try {
    const { MAC } = JSON.parse(macInfo);
    mac = MAC;
  } catch (err) {
    mac = null;
  }

  if (!mac) {
    return (
      <>
        <div className={styles.blank}>
          <div className={classNames(styles.Img)}>
            <img src={hint} alt="" className={styles.backColor} />
          </div>
          <div className={styles.text}>抱歉，您访问的页面离家出走了</div>
          <div className={styles.retry}>
            <button type="button" className={styles.button} onClick={handleSkip}>
              随便逛逛
            </button>
          </div>
        </div>
      </>
    );
  }

  if (load) {
    return (
      <div className={styles.blank}>
        <div className={styles.load}>
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.blank}>
        <div className={classNames(styles.Img)}>
          <img src={hint} alt="" className={styles.backColor} />
        </div>
        {!more && (
          <>
            {' '}
            <div className={styles.text}>这里空空如也，快去挑选喜欢的壁纸吧</div>
            <div className={styles.retry}>
              <button type="button" className={styles.button} onClick={handleSkip}>
                随便逛逛
              </button>
            </div>
          </>
        )}

        {more && <div className={styles.text}>壁纸持续扩充中，敬请留意：）</div>}
      </div>
    </>
  );
});
